module.exports = __webpack_public_path__ + "img/binding-process2.png";